//import { includes } from 'core-js/core/array'
import { inArray } from 'highcharts'
import SparkMD5 from 'spark-md5'
export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function() {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}
export function scorePassword(pass) {
  let score = 0
  if (!pass) {
    return score
  }
  // award every unique letter until 5 repetitions
  const letters = {}
  for (let i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1
    score += 5.0 / letters[pass[i]]
  }

  // bonus points for mixing it up
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  }

  let variationCount = 0
  for (var check in variations) {
    variationCount += (variations[check] === true) ? 1 : 0
  }
  score += (variationCount - 1) * 10

  return parseInt(score)
}

/**
 * 过滤对象中为空的属性
 * @param obj
 * @returns {*}
 */
export function filterObj(obj) {
  if (!(typeof obj == 'object')) {
    return;
  }

  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) &&
      (obj[key] == null || obj[key] == undefined)) {
      // || obj[key] === ''
      delete obj[key];
    }
  }
  return obj;
}
//
/**
 * 遍历路由获取所有path
 * @param array
 * @returns []
 */
export function familyTree(arr1) {
  // 返回数据集合
  var temp = [];
  // 声明digui函数
  var forFn = function (arr) {
    // 遍历树
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      if (item.path) {
        temp.push(item.path)
      }
      if (item.children) {
        forFn(item.children);
      }
    }
  };
  // 调用函数
  forFn(arr1);
  return temp
}

/**
 * 获取文件的md5
 * @param file
 * @returns []
 */
export function getFileMd5(file) {
  return new Promise((resolve) => {
    var tmp_md5;
    var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
        // file = this.files[0],
        chunkSize = 8097152, // Read in chunks of 2MB
        chunks = Math.ceil(file.size / chunkSize),
        currentChunk = 0,
        spark = new SparkMD5.ArrayBuffer(),
        fileReader = new FileReader();

    fileReader.onload = function (e) {
        spark.append(e.target.result); // Append array buffer
        currentChunk++;
        var md5_progress = Math.floor((currentChunk / chunks) * 100);
        console.log(file.name + "  正在处理，请稍等," + "已完成" + md5_progress + "%");
        if (currentChunk < chunks) {
            loadNext();
        } else {
            tmp_md5 = spark.end();
            console.log(file.name + "的MD5值是：" + tmp_md5)
            resolve(tmp_md5);
        }
    };
    fileReader.onerror = function () {
        console.warn('oops, something went wrong.');
    };
    function loadNext() {
        var start = currentChunk * chunkSize,
            end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  })
}



// 多维数组按id从小到大排序
export function sortByID(arr) {
     return arr.sort((a, b) => a.id - b.id);
}
//递归遍历法
export function findById(arr, id) 
{
  for (var item of arr) 
  {
    if (item.id === id)
	{
		return item
	}
	
    if (item.children) 
	{
      var found = findById(item.children, id);
      if (found) return found;
    }
  }
  return null;
}

export function findElementById(arr, idValue) {
  if (!Array.isArray(arr)) return null;
  return arr.find(item => item && typeof item === 'object' && 'id' in item && item.id === idValue);
}

//递归查找父级路径
export function findParentPath(tree, targetId, path = []) {
  for (const node of tree) {
    if (node.id === targetId) {
      return [...path, node]; // 找到目标节点，返回当前路径
    }
    if (node.children) {
      const result = findParentPath(node.children, targetId, [...path, node]);
      if (result) return result; // 子节点中找到则返回路径
    }
  }
  return null; // 未找到
}

//修改数组
export function modifyNestedArrayById(arr, id, modifyFn) {
  // 深拷贝原数组避免直接修改
  const newArray = JSON.parse(JSON.stringify(arr));
  
  function traverse(array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === id) {
        // 找到目标对象，执行修改函数
        modifyFn(array[i]);
        return true;
      }
      if (array[i].children && array[i].children.length) {
        // 递归遍历子数组
        if (traverse(array[i].children)) {
          return true;
        }
      }
    }
    return false;
  }

  traverse(newArray);
  return newArray;
}
export function findByIdNumber(arr, targetId, counter = { value: 0 }) {
  for (const item of arr) {
    counter.value++ // 每次检查计数+1
    if (item.id === targetId) return { item, count: counter.value }
    
    if (item.children && item.children.length) {
      const found = findByIdNumber(item.children, targetId, counter)
      if (found) return found
    }
  }
  return null
}

/**
 * 深度遍历多维数组并根据指定key修改匹配的对象
 * @param {Array} array - 要遍历的多维数组
 * @param {string} targetKey - 要查找的目标key
 * @param {*} targetValue - 要匹配的key值
 * @param {Function} modifier - 修改对象的回调函数
 * @returns {Array} 修改后的新数组
 */
export function modifyNestedArrayByKeyName(array, targetKey, targetValue, modifier) {
  // 创建深拷贝避免修改原数组
  const newArray = JSON.parse(JSON.stringify(array));
  
  // 递归遍历函数
  function traverse(arr) {
    for (let item of arr) {
      if (item[targetKey] === targetValue) {
        modifier(item);
        return true;
      }
      if (item.children && Array.isArray(item.children)) {
        if (traverse(item.children)) {
          return true;
        }
      }
    }
    return false;
  }

  traverse(newArray);
  return newArray;
}

export function modifyClassElements(arr,key,keyVal)  {
  if (!Array.isArray(arr)) return arr;
  
  return arr.map(item => {
    if (item && typeof item === 'object') {
      // 创建新对象避免修改原引用
      const newItem = {...item};
      
      // 修改当前对象的class值
      if ('class' in newItem && newItem.class === keyVal) {
        newItem.class = "active";
		newItem.icon = "caret-down";
      }
      
      // 递归处理children
      if (Array.isArray(newItem.children)) {
        newItem.children = modifyClassElements(newItem.children,key,keyVal);
      }
      
      return newItem;
    }
    return item;
  });
}



//查找数组
export function findDivElements(arr,value) {
	return arr.filter(item => item && typeof item === 'object' && 'div' in item && item.div === value);
}
//删除数组
export function removeDivElements(arr,value) {
  return arr.filter(item => !(item && typeof item === 'object' && 'id' in item && item.id === value));
}
//根据index删除数组
export function removeElementByIndex(arr, index) {
  if (index < 0 || index >= arr.length) {
    return arr;
  }
  return [...arr.slice(0, index), ...arr.slice(index + 1)];
}


/**
 * 获取文件的的扩展名
 * @param file
 * @returns string
 */
export function getCFileType(fileLink) {	
	var file_url=fileLink;
	file_url=file_url.replace("https://","").replace("http://","");
	var filePathArr=file_url.split('.');
	var type=filePathArr[filePathArr.length-1].toLowerCase();
	//console.log("type:",type);
	if(["png","jpg","jpge","gif","bmp"].indexOf(type)>=0){
		return "pic";
	}
	if(["xml","xls","xlsx","xla","csv","xlsm","xltx"].indexOf(type)>=0){
		return "xml";
	}
	if(["doc","docx","docm","dotx"].indexOf(type)>=0){
		return "word";
	}	
	if(["pdf"].indexOf(type)>=0){
		return "pdf";
	}
	return type;
}

//处理文件列表
export function getArtlist(artlist)
{	
	//var artlist=res.datas.data;
	for(var i=0;i<artlist.length;i++)
	{
		var item=artlist[i];		
		var file_url=item['file_url'];
		artlist[i]['type']="--";		
		artlist[i]['file_url_type']="";
		if(item.folder_id>0 && item.article_id==0)
		{			
			artlist[i]['type']="dir";
		}
		if(item.folder_id>0 && item.article_id>0)
		{			
			artlist[i]['type']="list";	
			artlist[i]['file_url_type']=getCFileType(file_url);		
		}		 		
		if(item.folder_id==0 && item.article_id>0)
		{
			artlist[i]['type']="pic";
			artlist[i]['file_url_type']=getCFileType(file_url);	
		}
		 //console.log("getArtlist-"+i+":",artlist[i]['type'],artlist[i]['article_id'],artlist[i]['article_class_id']);	 
		 
		  artlist[i]['cat']=artlist[i]['article_class_id'];//知识分类id

		  artlist[i]['read']=artlist[i]['is_read'];
		  artlist[i]['src']=artlist[i]['kk_preview_url'];
		  artlist[i]['ftitle']=artlist[i]['subtitle'];	  		
		  artlist[i]['desc']=artlist[i]['subtitle'];	
		   
		  //console.log("getArtlist-"+i+":",artlist[i]);
	}
	return sortById(artlist,'desc');
}
//根据id排序
function sortById(arr, order = 'asc') {
  return [...arr].sort((a, b) => {
    if (order === 'asc') {
      return a.id - b.id;
    } else {
      return b.id - a.id;
    }
  });
}

export function getArtItem(artlist,id)
{	
	//var artlist=res.datas.data;
	for(var i=0;i<artlist.length;i++)
	{
	  if(artlist[i]['id']===id)
	  {
		  return artlist[i]
	  }
	}
	return null;
}

export function getSizeHieght(windowWidth)
{
	console.log("windowWidth-----------------windowWidth:",windowWidth);
	var itemSizeHeight=95;
	if(windowWidth>=1025)
	{
		itemSizeHeight=95;
		
		if(windowWidth>=2560)
		{
			itemSizeHeight=165;
		}
		if(windowWidth>=2000 &&  windowWidth<2560)
		{
			itemSizeHeight=155;
		}
		if(windowWidth>=1900 &&  windowWidth<2000)
		{
			itemSizeHeight=135;
		}
		if(windowWidth>=1800 && windowWidth<1900)
		{
			itemSizeHeight=125;
		}
		if(windowWidth>=1700 && windowWidth<1800)
		{
			itemSizeHeight=115;
		}
		if(windowWidth>=1600 && windowWidth<1700)
		{
			itemSizeHeight=105;
		}		
		if(windowWidth>=1025 && windowWidth<1280)
		{
			itemSizeHeight=75;
		}
	}
	return itemSizeHeight;
}

//去重复
export function quChongArr(arr,key) {
  return arr.reduce((acc, current) => {
    const exists = acc.some(item => 
      key ? item[key] === current[key] : JSON.stringify(item) === JSON.stringify(current)
    );
    return exists ? acc : [...acc, current];
  }, []);
}